export default __webpack_public_path__ + "static/media/farmacias_sao_joao.2eb53296.png";